import {
  type ComponentProps,
  Fragment,
  type ReactElement,
  type ReactNode,
} from 'react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '~/components/ui/dropdown-menu';

export type DropMenuItem = {
  destructive?: boolean;
  id: string;
  label: ReactNode;
  onSelect: () => void;
  separatorBefore?: boolean;
};

type DropMenuProps = {
  items: readonly DropMenuItem[];
  onCloseAutoFocus?: ComponentProps<
    typeof DropdownMenuContent
  >['onCloseAutoFocus'];
  onContentClick?: ComponentProps<typeof DropdownMenuContent>['onClick'];
  trigger: ReactElement;
};

export const DropMenu = ({
  items,
  onCloseAutoFocus,
  onContentClick,
  trigger,
}: DropMenuProps): ReactElement => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
    <DropdownMenuContent
      align="start"
      avoidCollisions={false}
      className="w-max min-w-[120px] max-w-[calc(100vw-2rem)] rounded-xl border-transparent bg-elevated/95 shadow-xl overscroll-contain motion-reduce:animate-none"
      onCloseAutoFocus={onCloseAutoFocus}
      onClick={onContentClick}
      side="bottom"
      sideOffset={6}
    >
      {items.map(item => (
        <Fragment key={item.id}>
          {item.separatorBefore ? <DropdownMenuSeparator /> : null}
          <DropdownMenuItem
            onSelect={item.onSelect}
            variant={item.destructive ? 'destructive' : 'default'}
          >
            {item.label}
          </DropdownMenuItem>
        </Fragment>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
